<div class="home_novelty_container">
  <h3>Últimas novedades</h3>
  <div class="home_novelty">
    <ng-container *ngFor="let item of data; let RowIndex = index">
      <div class="novelty">
        <a *ngIf="item.ExternalUrl == true" [href]="item.Url" (click)="TrackNovelty(item.IdElement)"
          [attr.target]="item.UrlOpenNew ? '_blank' : null" [attr.rel]="item.UrlOpenNew ? 'noopener noreferrer' : null">
          <div>
            <div class="novelty_title">{{item.Title}}</div>
            <div [innerHTML]="item.Content" class="novelty_text external-html"></div>
          </div>
          <div class="novelty_date">{{item.PublishDate | date: 'dd/MM/yyyy'}}</div>
        </a>
        <a *ngIf="item.ExternalUrl == false" [attr.href]="item.Url" (click)="TrackNovelty(item.IdElement)"
          [attr.target]="item.UrlOpenNew ? '_blank' : null">
          <div>
            <div class="novelty_title">{{item.Title}}</div>
            <div [innerHTML]="item.Content" class="novelty_text external-html"></div>
          </div>
          <div class="novelty_date">{{item.PublishDate | date: 'dd/MM/yyyy'}}</div>
        </a>
      </div>
    </ng-container>
  </div>
</div>